import { getAttributeValue, parseHtml } from '@theme/dom';
import { publish } from '@theme/event-bus';
import { text } from '@theme/fetch';
import { isInViewport } from '@theme/helpers';
import { HTMLCustomElement } from '@theme/html-custom-element';

class MainBlogFilter extends HTMLCustomElement {
  get button() {
    return this.refs.button ?? this.firstElementChild;
  }

  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    this.on('click', this.button, (event) => {
      event.preventDefault();

      publish('main-blog-filter', event.currentTarget.href);
    });
  }
}

class MainBlog extends HTMLCustomElement {
  connectedCallback() {
    if (super.connectedCallback) super.connectedCallback();

    this.subscribe('main-blog-filter', this.handleFilter.bind(this));
  }

  /**
   * Handles the filter event.
   * @param {string} href - The filter href.
   */
  handleFilter(href) {
    const url = new URL(href, location.origin);
    const sectionId = getAttributeValue(this, 'section-id', 'main-blog');

    url.hash = '';
    url.searchParams.append('section_id', sectionId);

    /**
     * Fetch the requested filter address and display it.
     */
    try {
      text(fetch(url.toString())).then((response) => {
        const updatedSection = parseHtml(response, `#shopify-section-${sectionId}`);
        const parentSection = this.closest(`#shopify-section-${sectionId}`);

        if (updatedSection && parentSection) {
          parentSection.innerHTML = updatedSection.innerHTML;

          /**
           * Update the address bar.
           */
          url.searchParams.delete('section_id');

          history.pushState({}, '', url.toString());

          if (!isInViewport(parentSection)) {
            parentSection.scrollIntoView();
          }
        }
      });
    } catch {
      window.location = href;
    }
  }
}

if (!customElements.get('main-blog-filter')) customElements.define('main-blog-filter', MainBlogFilter);
if (!customElements.get('main-blog')) customElements.define('main-blog', MainBlog);
